import { useEffect, useState } from 'react'
import { avatarColor } from './AvatarStack'
import { gravatarUrl } from '@/utils/gravatar'

interface UserAvatarProps {
  userId: number
  name: string
  email: string
  size?: number
  color?: string
}

export function userInitials(name: string): string {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('')
}

export function UserAvatar({ userId, name, email, size = 30, color }: UserAvatarProps) {
  const [src, setSrc] = useState<string | null>(null)
  const [imgFailed, setImgFailed] = useState(false)
  const label = name || email
  const fontSize = size <= 24 ? 9 : size <= 32 ? 11 : 13

  useEffect(() => {
    setSrc(null)
    setImgFailed(false)
    void gravatarUrl(email, size * 2).then(setSrc)
  }, [email, size])

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        flexShrink: 0,
        background: color ?? avatarColor(userId),
        color: '#fff',
        fontSize,
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      {userInitials(label)}
      {src && !imgFailed && (
        <img
          src={src}
          alt=""
          onError={() => setImgFailed(true)}
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
        />
      )}
    </div>
  )
}
